import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import { AnalogInput } from 'z3k-config';
export const ShowAnalogInputValue = memo(function ShowAnalogInputValue(props) {
    const { state, analog_input } = props;
    if (state == null || state.value == null) {
        return null;
    }
    const is_boolean_sensor = useMemo(() => AnalogInput.booleanSensorsTypes.includes(AnalogInput.getType(analog_input)), [analog_input]);
    const value = useMemo(() => {
        if (is_boolean_sensor) {
            return null;
        }
        const sensor_value = AnalogInput.getValueHuman(analog_input, state);
        const unit = AnalogInput.getUnit(analog_input);
        return `${sensor_value} ${unit}`;
    }, [analog_input, state]);
    return value != null ? _jsx(Typography, { children: value }) : null;
});
